
export const base64ToArrayBuffer = (base64: string): ArrayBuffer => {
    const binaryString = atob(base64);
    const length = binaryString.length;
    const bytes = new Uint8Array(length);
    for (let i = 0; i < length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
};

export const arrayBufferToBase64 = (buffer: ArrayBuffer): string => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
};

export const arrayBufferToFile = (arrayBuffer: ArrayBuffer, fileName: string, fileType: string): File => {
    const blob = new Blob([arrayBuffer], { type: fileType });
    return new File([blob], fileName, { type: fileType });
};

export const getMimeTypeFromBase64DataUri = (base64String: string): string | undefined => {
    const prefix = base64String.substring(0, base64String.indexOf(','));
    if (prefix.startsWith('data:') && prefix.endsWith(';base64')) {
        return prefix.substring(5, prefix.length - 7);
    }
    return;
};

export const getExtensionFromMimeType = (mimeType: string): string | undefined => {
    let ext = mimeType.substring(mimeType.indexOf('/')+1);
    switch (mimeType) {
        case 'audio/mpeg':
            ext = 'mp3';
            break;
        case 'audio/x-m4a':
        case 'audio/mp4':
            ext = 'm4a';
            break;
        default: break;
    }
    return ext;
};
